import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CustomScalarTypeClass;
function CustomScalarType() {
  if (CustomScalarTypeClass === VOID) {
    class $ extends CompiledNamedType() {
      constructor(name, className) {
        super(name);
        this.k45_1 = className;
      }
    }
    initMetadataForClass($, 'CustomScalarType');
    CustomScalarTypeClass = $;
  }
  return CustomScalarTypeClass;
}
var CompiledNamedTypeClass;
function CompiledNamedType() {
  if (CompiledNamedTypeClass === VOID) {
    class $ extends CompiledType() {
      constructor(name) {
        super();
        this.l45_1 = name;
      }
    }
    initMetadataForClass($, 'CompiledNamedType');
    CompiledNamedTypeClass = $;
  }
  return CompiledNamedTypeClass;
}
var CompiledTypeClass;
function CompiledType() {
  if (CompiledTypeClass === VOID) {
    class $ {}
    initMetadataForClass($, 'CompiledType');
    CompiledTypeClass = $;
  }
  return CompiledTypeClass;
}
var EnumTypeClass;
function EnumType() {
  if (EnumTypeClass === VOID) {
    class $ extends CompiledNamedType() {
      constructor(name, values) {
        super(name);
        this.n45_1 = values;
      }
    }
    initMetadataForClass($, 'EnumType');
    EnumTypeClass = $;
  }
  return EnumTypeClass;
}
//region block: exports
export {
  CustomScalarType as CustomScalarType8w7iuefxipic,
  EnumType as EnumType11cgb4df0n5r9,
};
//endregion

//# sourceMappingURL=CompiledGraphQL.mjs.map
